import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { ElInput } from 'element-ui/types/input';

import InputableTextBaseMixin, { InputType } from '@/entries/user/mixins/InputableTextBaseMixin';

type Value = string | number | undefined;

const REGEXP_NUMBER = RegExp(/^[-]?([1-9]\d*|0)(\.\d+)?$/);
const REGEXP_INTEGER = RegExp(/^[-]?([1-9]\d*|0)$/);

// InputableText を使う画面でfieldTypeを設定する際に使用することを想定
export const InputableTextMixin = Vue.extend({
  name: 'InputableTextMixin',

  data(): {
    itInputType: typeof InputType;
  } {
    return {
      itInputType: InputType,
    };
  },
});

export default mixins(InputableTextMixin, InputableTextBaseMixin).extend({
  name: 'InputableText',

  props: {
    // componentの外からisActiveを変更する用（KeystrokeInputableTextで使用する）
    isForceActive: {
      type: Boolean,
      default: false,
    },
    reload: {
      type: Number,
      required: false,
    },
  },

  data(): {
    isActive: boolean;
    inputValue: Value;
    oldReload: number;
  } {
    return {
      isActive: false,
      inputValue: '',
      oldReload: 0,
    };
  },

  watch: {
    value: {
      handler(): void {
        this.inputValue = this.value;
      },
      immediate: true,
    },
    inputValue(newVal: Value, oldVal: Value): void {
      if (this.reload != undefined && this.oldReload != this.reload) {
        this.oldReload = this.reload;
        return;
      }
      switch (this.type) {
        case InputType.integer:
          this.$_checkInputValue(REGEXP_INTEGER, oldVal);
          break;
        case InputType.number:
          this.$_checkInputValue(REGEXP_NUMBER, oldVal);
          break;
        default:
          break;
      }
      this.$emit('update:value', this.inputValue);
    },
    isActive(): void {
      if (!this.isActive && this.inputValue !== this.value) this.$emit('change', this.inputValue);
    },
    isForceActive: {
      handler(): void {
        if (this.isForceActive) this.focus();
      },
      immediate: true,
    },
  },

  methods: {
    async focus(): Promise<void> {
      if (this.isActive) return;
      this.isActive = true;
      await this.$nextTick();
      (this.$refs.input as ElInput).focus();
    },
    onFocusNumber(): void {
      if (this.inputValue === 0) this.inputValue = undefined;
      this.onFocus();
    },
    onBlur(): void {
      this.isActive = false;
      this.$emit('blur');
    },
    onBlurNumber(): void {
      this.onBlur();
      if (this.inputValue === undefined) this.inputValue = 0;
    },
    isMinus(value: string | number): boolean {
      switch (this.type) {
        case InputType.integer:
        case InputType.number:
          return (value as number) < 0;
        default:
          return false;
      }
    },
    $_checkInputValue(regExp: RegExp, oldVal: Value): void {
      if (this.inputValue === undefined) {
        // focus 時は undefined を補正せずに入力欄を空状態で表示する
        if (oldVal === 0) return;
        this.inputValue = 0;
      }
      // 正規表現のチェック不正の場合は元の値を設定する
      if (!regExp.test(String(this.inputValue))) this.inputValue = oldVal;
    },
    onFocus(): void {
      this.$emit('focus');
    },
  },
});
